module.exports = __webpack_public_path__ + "img/ico-profile.e58b6b00.svg";